import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import ServiceSidebar from '../components/ServiceSidebar'

function ServiceMicroLending() {
    return (
        <>
            <PageHeader title="Micro-Lending Services" />

            <div className="page-service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <ServiceSidebar
                                activeService="/service-micro-lending"
                                ctaTitle="Need Funding? Apply Today!"
                                ctaLabel="Loan inquiries"
                            />
                        </div>
                        <div className="col-lg-8">
                            <div className="service-single-content">
                                <div className="service-featured-image">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/micro-lending.jpg`}
                                            alt="Micro-Lending Services"
                                        />
                                    </figure>
                                </div>
                                <div className="service-entry">
                                    <h2 className="text-anime-style-2">
                                        Empowering Dreams Through Micro-Lending
                                    </h2>
                                    <p className="wow fadeInUp">
                                        Our micro-lending services are tailored
                                        to provide quick, accessible financing
                                        for individuals and small businesses in
                                        Nigeria. Whether you're starting a side
                                        hustle, expanding your enterprise, or
                                        covering unexpected expenses, we offer
                                        flexible loans from ₦50,000 to
                                        ₦5,000,000 that bridge the gap between
                                        ambition and achievement.
                                    </p>
                                    <div className="service-cta-box text-center wow fadeInUp">
                                        <h3>
                                            Ready to turn your ideas into
                                            reality?
                                        </h3>
                                        <Link
                                            to="/contact"
                                            className="btn-default btn-highlighted"
                                        >
                                            Apply for a Loan
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceMicroLending
